// extracted by mini-css-extract-plugin
export default {"overlay":"Modal_overlay__f91tS","modal":"Modal_modal__bBZYF","title":"Modal_title__c+yC4","title__icon":"Modal_title__icon__P1GGq","title__text":"Modal_title__text__mzEEJ"};